import { useCallback, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import GroceryCmp from "../Components/Grocery/Grocery";
import useTitle from "../hooks/useTitle";
import { useDispatch, useSelector } from "react-redux";
import { itemsActions } from "../store/itemStore";

const Grocery = () => {
  useTitle("Edit Page");
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { groceryID } = params;
  const groceryItems = useSelector((state) => state.items.groceryItems);
  const getGroceryItem = useCallback(() => {
    const groceryItem = groceryItems.find((groceryItem) => groceryItem.id.toString() === groceryID);
    if (groceryItem) {
      dispatch(itemsActions.onEditing({ isEditing: true, editDetails: groceryItem }));
      return;
    }
    history.push("/not_found");
  }, [dispatch, history, groceryItems, groceryID]);
  useEffect(() => {
    if (groceryItems) {
      return getGroceryItem();
    }
    history.push("/not_found");
  }, [groceryItems, history, getGroceryItem]);

  return <GroceryCmp />;
};

export default Grocery;
